<template>
  <div class="tag-anchor" :style="styles" :id="$attrs._id">
    <div 
      class="tag-line"
      :style="lineStyle"
    ></div>
    <div 
      v-if="tailPosition !== 'none'"
      class="tag-dot"
    ></div>
    <div
      class="tag-rich"
      :class="classes"
      :style="labelStyle"
      @click="triggerAction"
    >
      <div
        class="tag-rich__inner"
        :class="{ 'tag-rich__inner--expand' : active && !action.method }"
      >
        <div
          v-if="label"
          class="tag-rich__content-col"
          :class="[
            { 'dir-rtl' : activeLanguage.rtl },
            { 'tag-rich__content-col--overlay-hidden': overlayContent && (!label[activeLanguage.code] && !description[activeLanguage.code]) }
          ]"
        >
          <div class="tag-rich__label" v-html="label[activeLanguage.code]"></div>
          <div class="tag-rich__description" v-html="description[activeLanguage.code]"></div>
          <div v-if="(moreInformation[activeLanguage.code] || qrUrl) && !overlayContent" class="tag-rich__info-icon">[MORE]</div>
        </div>

        <template v-if="useQRTemplate">
          <div
            v-if="!overlayContent"
            class="tag-rich__content-col-extra"
            :class="{ 'dir-rtl' : activeLanguage.rtl }"
          >
            <div class="tag-rich__description tag-rich__description--centered">Scan QR code<br>for more information</div>
            <div class="tag-rich__qr tag-rich__qr--centered">
              <qrcode-vue render-as="canvas" background="#fff" :value="qrUrl" />
            </div>
          </div>
        </template>

        <template v-if="!useQRTemplate">
          <div
            v-if="moreInformation[activeLanguage.code] && !overlayContent"
            class="tag-rich__content-col-extra"
            :class="{ 'dir-rtl' : activeLanguage.rtl }"
          >
            <div v-if="qrUrl" class="tag-rich__qr">
              <qrcode-vue render-as="canvas" background="#fff" :value="qrUrl" />
            </div>
            <div class="tag-rich__description" v-html="moreInformation[activeLanguage.code]"/>
          </div>
        </template>

        <div v-if="asset" class="tag-rich__asset-col">
          <div class="tag-rich__asset-col__overlay" :style="overlayOpacityStyle"></div>
          <div class="tag-rich__asset">
            <div v-if="icon" class="tag-rich__action-icon">
              <fa :icon="icon"/>
            </div>
            <img
              v-if="asset.type === 'image'"
              class="asset-cover"
              :src="`${$store.state.assetsPath}${asset.customThumbPath ? asset.customThumbPath : asset.thumbPath}`">
            <div
              v-if="asset.type === 'video'"
              class="tag-rich__asset-clip"
            >
              <video
                class="asset-cover"
                :src="`${$store.state.assetsPath + asset.path}`"
                autoplay
                muted
                loop
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  props: ['action', 'icon', 'pos', 'flip', 'overlay-content', 'overlay-opacity', 'label', 'tail-height', 'tail-position', 'description', 'asset', 'active', 'more-information', 'qrUrl'],

  components: {
    QrcodeVue,
  },

  data () {
    return {
      wooshCloseSound: null,
      wooshOpenSound: null
    }
  },

  watch: {
    active () {
      if (this.active) {
        this.wooshOpenSound.pause()
        this.wooshOpenSound.currentTime = 0
        this.wooshOpenSound.play()
      } else {
        this.wooshCloseSound.pause()
        this.wooshCloseSound.currentTime = 0
        this.wooshCloseSound.play()        
      }
    }
  },

  computed: {
    activeLanguage () {
      return this.$store.getters.language
    },

    classes () {
      let classes = {}
      classes[`tag-rich--tail-${this.tailPosition}`] = true
      classes['tag-rich--flip'] = this.forceFlip
      classes['tag-rich--overlay-content'] = this.overlayContent
      return classes
    },

    forceFlip () {
      if (this.tailPosition.includes('right-center')) {
        return true
      }

      if (this.tailPosition.includes('left-center')) {
        return false
      }

      return this.flip
    },

    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    },

    overlayOpacityStyle () {
      return {
        background: `rgba(0, 0, 0, ${this.overlayOpacity})`
      }
    },

    labelStyle () {
      switch (this.tailPosition) {
        case 'none':
          return ``
        
        case 'bottom-left':
          return `
            bottom: 0;
            transform: translate(-1em, -${this.tailHeight}em);
          `

        case 'bottom-center':
          return `
            bottom: 0;
            left: 50%;
            transform: translate(-50%, -${this.tailHeight}em);
          `

        case 'bottom-right':
          return `
            bottom: 0;
            right: 0;
            transform: translate(1em, -${this.tailHeight}em);
          `

        case 'top-left':
          return `
            transform: translate(-1em, ${this.tailHeight}em);
          `

        case 'top-center':
          return `
            left: 50%;
            transform: translate(-50%, ${this.tailHeight}em);
          `

        case 'top-right':
          return `
            right: 0;
            transform: translate(1em, ${this.tailHeight}em);
          `

        case 'left-center':
          return `
            left: 0;
            top: .125em;
            transform: translate(${this.tailHeight}em, -50%);
          `

        case 'right-center':
          return `
            right: 0;
            top: .125em;
            transform: translate(-${this.tailHeight}em, -50%);
          `
      
        default:
          return ''
      }
    },

    lineStyle () {
      switch (this.tailPosition) {
        case 'none':
          return `display: none;`
        
        case 'bottom-left':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'bottom-center':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'bottom-right':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'top-left':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'top-center':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'top-right':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'left-center':
          return `
            height: .25em;
            right: 0;
            top: -.125em;
            width: ${this.tailHeight}em;
            transform: translateX(0);
            z-index: 6;
          `

        case 'right-center':
          return `
            height: .25em;
            left: 0;
            top: -.125em;
            width: ${this.tailHeight}em;
            transform: translateX(-${this.tailHeight}em);
            z-index: 6;
          `
      
        default:
          return ''
      }
    },

    useQRTemplate () {
      if (!this.moreInformation[this.activeLanguage.code] && this.qrUrl) { return true }
    }
  },

  mounted () {
    this.wooshCloseSound = new Audio('/assets/sounds/woosh_close.mp3')
    this.wooshOpenSound = new Audio('/assets/sounds/woosh_open.mp3')
  },

  methods: {
    triggerAction () {
      if (this.action && this.action.method) {
        this.$store.dispatch(`actions/${this.action.method}`, {
          payload: this.action.payload,
          tag: {
            label: this.label
          },
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transform: translateY(1em);
  transition: opacity 1.2s, transform 0.6s;
  z-index: 15;

  &.enter {
    opacity: 1;
    transform: translateY(0);
    
    .tag-rich__asset-col .tag-rich__asset {
      transform: translateX(0);
      transition: all 750ms ease-out 350ms;
    }
  }

  &.leave {
    .tag-rich__asset-col .tag-rich__asset {
      transform: translateX(0);
      transition: all 750ms ease-out 350ms;
    }  
  }

  div[class*=' tag-rich--tail-top-left'] {
    
    .tag-rich__inner {
      transform-origin: 0% 0%;
    }
  }

  div[class*=' tag-rich--tail-top-right'] {
    
    .tag-rich__inner {
      transform-origin: 50% 0%;
    }
  }

  div[class*=' tag-rich--tail-top-center'] {
    
    .tag-rich__inner {
      transform-origin: 25% 0%;
    }
  }

  div[class*=' tag-rich--tail-bottom-left'] {
    .tag-rich__inner {
      transform-origin: 0% 100%;
    }
  }

  div[class*=' tag-rich--tail-bottom-right'] {
    .tag-rich__inner {
      transform-origin: 50% 100%;
    }
  }

  div[class*=' tag-rich--tail-bottom-center'] {
    .tag-rich__inner {
      transform-origin: 25% 100%;
    }
  }

  div[class^='tag-rich--tail-right'],
  div[class*=' tag-rich--tail-right'] {
    
    .tag-rich__inner {
      transform-origin: right;
    }
  }

  div[class^='tag-rich--tail-right-center'],
  div[class*=' tag-rich--tail-right-center'] {
    
    .tag-rich__inner {
      transform-origin: center;
    }
  }

  div[class^='tag-rich--tail-left'],
  div[class*=' tag-rich--tail-left'] {
    
    .tag-rich__inner {
      transform-origin: left;
    }
  }

  &.enter {
    opacity: 1;
    transform: translateY(0);
    
    .tag-rich__asset-col .tag-rich__asset {
      transform: translateX(0);
    }
  }

  &.leave {
    .tag-rich__asset-col .tag-rich__asset {
      transform: translateX(0);
    }  
  }
}

.tag-dot {
  background: $basic-tag-bg-color;
  border-radius: 50%;
  bottom: -.25em;
  height: .5em;
  left: -.25em;
  pointer-events: auto;
  position: absolute;
  width: .5em;

  &--white {
    background-color: rgba($white, .8);
    color: $black;
  }

  &--orange {
    background-color: $basic-tag-orange-color;
    color: $black;
  }

  &--blue {
    background-color: $basic-tag-blue-color;
    color: $black;
  }
}

.tag-line {
  background: $basic-tag-bg-color;
  left: -.125em;
  pointer-events: auto;
  position: absolute;
  width: .25em;
}

.tag-rich {
  background-color: transparent;
  color: $rich-tag-font-color;
  font-size: $rich-tag-font-size;
  height: 15em;
  letter-spacing: .05em;
  line-height: 1.2em;
  overflow: visible;
  pointer-events: none;
  position: absolute;
  transition: all 350ms ease-in-out;
  width: 18em;
  z-index: 5;

  * {
    pointer-events: none;
    user-select: none;
  }

  &--flip {
    .tag-rich__inner {
      transform-origin: left;

      &--expand {
        .tag-rich__content-col-extra {
          border-bottom-left-radius: $rich-tag-border-radius;
          border-top-left-radius: $rich-tag-border-radius;
          border-bottom-right-radius: 0;
          border-top-right-radius: 0;
          transform: translateX(-95%);
        }
      }
    }

    .tag-rich__asset-col {
      transform: translateX(-195%);

      .tag-rich__asset-clip {
        clip-path: polygon(98% 0%, 96% 1%, 95.5% 2%, 95% 3%, 95% 50%, 95% 97%, 95.5% 98%, 96% 99%, 98% 100%, 0% 100%, 0% 50%, 0% 0%);
        height: 100%;
      }

      .asset-cover {
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }

      .tag-rich__asset {
        height: 100%;
        transform: translateX(92%);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;

        .tag-rich__action-icon {
          left: initial;
          right: 2rem;
          position: absolute;
          bottom: 1rem;
        }
      }
    }
  }

  &--overlay-content {
    .tag-rich__inner {
      width: 18em;
    }

    .tag-rich__content-col,
    .tag-rich__asset-col {
      position: absolute;
      width: 100%;
    }

    .tag-rich__content-col {
      background: transparent;
    }

    .tag-rich__asset-col {
      border-radius: $default-border-radius;
      transform: translateX(0);

      &__overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
      }
    }

    .tag-rich__asset-clip {
      clip-path: none !important;
    }
  }

  &__inner {
    display: flex;
    height: 15em;
    position: absolute;
    transition: transform 300ms ease;
    width: 36em;

    &--expand {
      transform: scale(1.25);

      .tag-rich__content-col-extra {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        transform: translateX(97%);
      }
    }
  }

  &__action-icon {
    border-radius: 100%;
    bottom: 1rem;
    height: 2rem;
    left: 1.5rem;
    padding: .15rem;
    position: absolute;
    right: initial;
    width: 2rem;
    z-index: 10;

    svg {
      filter: drop-shadow(0 0 .1rem rgba(0, 0, 0, .7));
      height: 100%;
      width: 100%;
    }
  }

  &__asset-col {
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    left: 0;
    top: 0;
    width: 50%;
    filter: drop-shadow($tag-box-shadow);
    overflow: hidden;
    pointer-events: auto;
    position: relative;
    transform: translateX(-3%);
  }

  &__asset-clip {
    clip-path: polygon(100% 0%, 100% 50%, 100% 100%, 0% 100%, 2% 99%, 2.5% 98%, 3% 97%, 3% 50%, 3% 3%, 2.5% 2%, 2% 1%, 0% 0%);
    height: 100%;
  }

  &__asset {
    height: 100%;
    transform: translateX(-92%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;

    .asset-cover {
      border-radius: $rich-tag-border-radius;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__content-col {
    background: $rich-tag-bg-color;
    border-radius: $rich-tag-border-radius;
    box-shadow: $tag-box-shadow;
    height: 100%;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: relative;
    width: 50%;
    z-index: 2;
  }

  &__content-col-extra {
    background: rgba($rich-tag-bg-color, .8);
    border-radius: $rich-tag-border-radius;
    box-shadow: none;
    height: 100%;
    left: 0;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: absolute;
    transition: 300ms all 100ms ease-in-out;
    width: 50%;
    z-index: 1;
  }

  &__label {
    font-size: 1.3em;
    font-weight: 300;
    line-height: 1.1em;
    margin-bottom: .6em;
    margin-top: .1em;
    -webkit-font-smoothing: auto;
  }

  &__description {
    font-size: 0.75em;
    font-weight: 200;
    line-height: 1.4;

    &--centered {
      text-align: center;
    }
  }

  &__qr {
    background: #fff;
    height: 5em;
    float: right;
    padding: .1em .15em .15em .1em;
    width: 5em;

    /deep/ canvas {
      height: 100% !important;
      width: 100% !important;
    }

    &--centered {
      float: initial;
      margin: 2.5rem auto 0;
    }
  }

  &__info-icon {
    bottom: .5em;
    font-size: .8em;
    position: absolute;
    right: .75em;
  }
}
</style>